import { Component } from '@angular/core';
import { environment } from '../../../../../../public/environments/environment';
import { Router } from '@angular/router';
import { register } from 'swiper/element/bundle';
import { ApiService } from '../../services/Api.service';
import { GoogleAnalyticsService } from '../../services/googleAnalytics.service';
register();

@Component({
  selector: 'app-home-new',
  standalone: false,
  templateUrl: './home-new.component.html'
})
export class HomeNewComponent {
  lang = localStorage.getItem('language') || 'ar';
  env = environment;

  searchText = '';
  statistics: any;
  domains: any;
  cities: any;

  constructor(
    private router: Router,
    private apiService: ApiService,
    public analytics: GoogleAnalyticsService
  ) {
    this.GetHomeData();
  }

  clients = [
    'assets/images/home/clients/2222.SR_BIG 1.svg',
    'assets/images/home/clients/Al_Rajhi_Bank_Logo 2.svg',
    'assets/images/home/clients/Alawal_Bank_Logo 2.svg',
    'assets/images/home/clients/Logo_Saudi_Arabian_Monetary_Authority 1.svg',
    'assets/images/home/clients/Logo_Saudi_Electric_Company 1.svg'
  ]

  counter(n: number) {
    return new Array(n);
  }

  onSubmit(event: Event) {
    event.preventDefault();
    if (this.searchText) {
      this.analytics.event('search', {
        search_term: this.searchText
      });
      this.router.navigate(['/jobs'], { queryParams: { search: this.searchText } });
    }
  }

  GetHomeData() {
    this.apiService.GetStatistics().subscribe((res: any) => {
      this.statistics = res;
    })
    this.apiService.GetTopCities().subscribe((res: any) => {
      this.cities = res;
    })
    let domainFilter = { perPage: 12, page: 1 };
    this.apiService.getDomains(domainFilter).subscribe((res: any) => {
      this.domains = res;
    })
  }

  trackTopSearch(term: string) {
    this.analytics.event('top_search_click', { term });
  }
  trackSource(source: string, item: any) {
    this.analytics.event(source, {
      id: item.id,
      name: item.name
    });
  }
}
